import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import api, { apiErr } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { ShieldCheck } from "lucide-react";

export default function ResetPassword() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (pw.length < 6) return toast.error("Password must be at least 6 characters");
    if (pw !== pw2) return toast.error("Passwords don't match");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password: pw });
      toast.success("Password updated — please sign in");
      navigate("/auth");
    } catch (e) { toast.error(apiErr(e)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center px-5">
      <div className="w-full max-w-md bg-white rounded-3xl p-7 shadow-[0_8px_32px_rgba(44,44,62,0.08)] animate-fade-up">
        <div className="h-12 w-12 rounded-2xl accent-bg mx-auto flex items-center justify-center text-white mb-3"><ShieldCheck className="h-6 w-6" /></div>
        <h1 className="font-heading font-bold text-2xl text-[var(--brand-navy)] text-center mb-1">Set a new password</h1>
        {!token ? (
          <p className="text-sm text-destructive text-center mt-4">This reset link is invalid. Please request a new one.</p>
        ) : (
          <>
            <p className="text-sm text-muted-foreground text-center mb-6">Choose a new password for your account.</p>
            <Label className="text-sm text-[#2C2C3E]">New password</Label>
            <Input data-testid="reset-pw" type="password" className="mt-1.5 mb-3 rounded-xl h-11" value={pw} onChange={(e) => setPw(e.target.value)} />
            <Label className="text-sm text-[#2C2C3E]">Confirm password</Label>
            <Input data-testid="reset-pw2" type="password" className="mt-1.5 rounded-xl h-11" value={pw2} onChange={(e) => setPw2(e.target.value)} />
            <Button data-testid="reset-submit-btn" disabled={loading} onClick={submit} className="w-full mt-6 rounded-full accent-bg text-white h-12 hover:opacity-90">
              {loading ? "Saving…" : "Update password"}
            </Button>
          </>
        )}
      </div>
    </div>
  );
}
